import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import React, { Fragment, memo, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import Product from './Product';
import Subscription from './Subscription';

const useStyles = makeStyles(() => ({
  content: {
    marginTop: 16,
  },
  tabs: {
    borderBottom: '1px solid #d8d8d8',
    marginBottom: 16,
  },
  tab: {
    minWidth: 110,
  },
}));

export type ISubscriptionTabs = 'subscriptions' | 'products';

const Subscriptions = memo(() => {
  const classes = useStyles();
  const { tabName } = useParams<{ tabName: ISubscriptionTabs }>();

  const [tab, setTab] = useState<ISubscriptionTabs>(() => {
    if (!tabName || tabName === 'products') return 'products';
    return 'subscriptions';
  });

  const handleChange = useCallback((_: React.ChangeEvent<{}>, tab: ISubscriptionTabs) => {
    setTab(tab);
  }, []);

  return (
    <Fragment>
      <div>
        <Grid id='my-subscriptions' container justify='space-between' alignItems='flex-start'>
          <div className='my-title'>
            <h1>Minhas Compras</h1>
            <p>Gerencie e acesse os produtos que você adquiriu dentro da plataforma Eduzz.</p>
          </div>
        </Grid>

        <div className='m32' />

        <div>
          <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
            <Tab className={classes.tab} value='products' label='Produtos' />
            <Tab className={classes.tab} value='subscriptions' label='Assinaturas' />
          </Tabs>
          {tab === 'products' && <Product />}
          {tab === 'subscriptions' && <Subscription />}
        </div>
      </div>
    </Fragment>
  );
});

export default Subscriptions;
